import { render } from "./ProvideInject.vue?vue&type=template&id=e6fdf26c"
import script from "./ProvideInject.vue?vue&type=script&lang=ts"
export * from "./ProvideInject.vue?vue&type=script&lang=ts"
script.render = render

export default script